import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { withAreaPrefix } from '../../lib/area-routes';
import { AuthHydrationFallback } from './AuthHydrationFallback';

const TOKEN_KEY = 'ffshop_access_token';

interface ProtectedRouteProps {
  readonly children: React.ReactNode;
  readonly requiredScope?: string;
}

export function ProtectedRoute(props: ProtectedRouteProps) {
  const { children, requiredScope } = props;
  const { isAuthenticated, hasScope, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    const hasStoredToken = typeof localStorage !== 'undefined' && !!localStorage.getItem(TOKEN_KEY);
    if (!hasStoredToken) {
      return <Navigate to={withAreaPrefix('/auth/login', location.pathname)} replace />;
    }
    return null;
  }

  if (requiredScope && !hasScope(requiredScope)) {
    return <Navigate to={withAreaPrefix('/unauthorized', location.pathname)} replace />;
  }

  // Admin area is reserved for platform users only.
  if (location.pathname.startsWith('/admin')) {
    // After refresh, persist restores isAuthenticated before `user` is filled (JWT/profile in App effect).
    if (user == null) {
      return <AuthHydrationFallback />;
    }
    if (!user.isPlatformUser) {
      return <Navigate to={withAreaPrefix('/unauthorized', location.pathname)} replace />;
    }
  }

  return <>{children}</>;
}
